import { render, staticRenderFns } from "./TypeToSee.vue?vue&type=template&id=5625c9b6&scoped=true&"
import script from "./TypeToSee.vue?vue&type=script&lang=js&"
export * from "./TypeToSee.vue?vue&type=script&lang=js&"
import style0 from "./TypeToSee.vue?vue&type=style&index=0&id=5625c9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5625c9b6",
  null
  
)

export default component.exports